import { parseResponse } from "api/resources/handlers/parseResponse/parseResponse";
import { GetTcuListPayload } from "./getTcuList.fromApi.types";
import axios from "axios";
import { GET_TCU_LIST } from "api/resources/configs/URL";
import { getRequestOptions } from "api/resources/configs/requests";
import { formatGetTcuListErrorMessage } from "api/resources/messages/ErrorMessage";

const getTcuList = async (
  memberIdentifier: string,
): Promise<GetTcuListPayload> => {
  try {
    const response = await axios.post<GetTcuListPayload>(
      GET_TCU_LIST(),
      {
        MemberIdentifier: memberIdentifier,
      },
      getRequestOptions(),
    );
    return parseResponse(response, GET_TCU_LIST());
  } catch (error) {
    const msg = formatGetTcuListErrorMessage(GET_TCU_LIST());
    console.error(msg);
    throw error;
  }
};

export { getTcuList };
